export enum EmployeeTabs {
  Employees = 0,
  InactiveEmployees = 1,
  ImportCertificates = 2
}
